import {cookieStore} from 'libs/storage/storage';
import {FIRST_DAY_COOKIE, FIRST_VISIT_TIMESTAMP} from 'constants/cookie';
import {differenceInHours} from 'date-fns';

/**
 * Function which set FIRST_VISIT_TIMESTAMP and return value of cookie
 * @returns {string} first visit cookie
 */
const setFirstVisitDateCookie = () => {
    const firstVisitDate = String(new Date());
    cookieStore.set(FIRST_VISIT_TIMESTAMP, firstVisitDate);
    return firstVisitDate;
};

/**
 * Function which set timestamp cookies - (FIRST_VISIT_TIMESTAMP, FIRST_DAY_COOKIE)
 */
export const setTimeStampCookies = () => {
    let firstVisitDateCookie = cookieStore.get(FIRST_VISIT_TIMESTAMP);

    if (!firstVisitDateCookie) {
        firstVisitDateCookie = setFirstVisitDateCookie();
    }

    const oldFirstDayCookie = cookieStore.get(FIRST_DAY_COOKIE);
    const DAY_IN_HOURS = 24;
    const isFirstDay = differenceInHours(new Date(), firstVisitDateCookie) < DAY_IN_HOURS;

    if ((!isFirstDay && oldFirstDayCookie) || !oldFirstDayCookie) {
        cookieStore.set(FIRST_DAY_COOKIE, isFirstDay);
    }
};
